(function () {
	let autoplayIntervals = new Map();

	const stopVideo = (section) => {
    const videos = section.querySelectorAll('video');

		if (videos) {
			videos.forEach(video => {
				video.pause();
			});
		}
  }

	const playVideo = (section, width) => {
    const videos = section.querySelectorAll('video');
		const cards = section.querySelectorAll('.gallery-with-text__card');

		if (videos && cards) {
			cards.forEach(card => {
				if (card.querySelector('video')) {
					if (card.classList.contains('active') || width < 990) 
						card.querySelector('video').play();
					else 
						card.querySelector('video').pause();
				}
			});
		}
  }

	const activateCard = (card, section) => {
		if (!card) return;
		
		card.classList.add("active");
		const siblings = Array.from(card.parentElement.querySelectorAll('.gallery-with-text__card')).filter(c => c !== card);
		siblings.forEach(sibling => sibling.classList.remove("active"));
		
		setTimeout(function () {
			const linkOverlay = card.querySelector(".gallery-with-text__info .link--overlay");
			if (linkOverlay) {
				linkOverlay.classList.add("active");
			}
			siblings.forEach(sibling => {
				const siblingLink = sibling.querySelector(".gallery-with-text__info .link--overlay");
				if (siblingLink) {
					siblingLink.classList.remove("active");
				}
			});
		}, 100);

		if (section) {
			playVideo(section, document.documentElement.clientWidth);
		}
	};

	const startAutoplay = (section) => {
		const sectionElement = section.querySelector('.gallery-with-text');
		if (!sectionElement) return;
		
		const autoplayEnabled = sectionElement.getAttribute('data-autoplay') === 'true';
		if (!autoplayEnabled) return;

		const delay = parseInt(sectionElement.getAttribute('data-autoplay-delay')) * 1000 || 5000;
		const cards = Array.from(section.querySelectorAll('.gallery-with-text__card'));
		
		if (cards.length <= 1) return;

		let currentIndex = cards.findIndex(card => card.classList.contains('active'));
		if (currentIndex === -1) currentIndex = 0;

		const intervalId = setInterval(() => {
			currentIndex = (currentIndex + 1) % cards.length;
			activateCard(cards[currentIndex], section);
		}, delay);

		autoplayIntervals.set(section, intervalId);
	};

	const stopAutoplay = (section) => {
		if (autoplayIntervals.has(section)) {
			clearInterval(autoplayIntervals.get(section));
			autoplayIntervals.delete(section);
		}
	};

	const galleryTextSlide = () => {	
		$(".gallery-with-text__card").hover(function () {
			let $this = $(this);
			const section = $this.closest('.gallery-with-text-section')[0];
			
			// Stop autoplay on hover
			stopAutoplay(section);
			
			activateCard(this, section);
		}, function() {
			// Resume autoplay when hover ends
			const section = $(this).closest('.gallery-with-text-section')[0];
			startAutoplay(section);
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.gallery-with-text-section');

		const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
					if (entry.isIntersecting) {
						playVideo(entry.target, entry.boundingClientRect.width);
						startAutoplay(entry.target);
					} else {
						stopVideo(entry.target);
						stopAutoplay(entry.target);
					}
			})
		});

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			let widthSlide = '100%';
			if (document.documentElement.clientWidth >= 990) {
				entry.target.querySelectorAll('.gallery-with-text__card').forEach(card => {
					if (card.classList.contains('active')) {
						widthSlide = card.getBoundingClientRect().width;
					}
				})
				entry.target.style.setProperty("--width-slide", `${widthSlide}px`);
			}
			else {
				entry.target.style.setProperty("--width-slide", '100%');
			}
			playVideo(entry.target, entry.contentRect.width);
		})

		sections.forEach(section => {
      sectionObserver.observe(section);
			sectionResizeObserver.observe(section);
			
			// Start autoplay if section is visible
			const rect = section.getBoundingClientRect();
			if (rect.top < window.innerHeight && rect.bottom > 0) {
				startAutoplay(section);
			}
    });

		galleryTextSlide();
	}

	document.addEventListener("shopify:section:load", function (event) {
		// Stop existing autoplay for this section
		if (event.target.classList.contains('gallery-with-text-section')) {
			stopAutoplay(event.target);
		}
		initSection();
	});

	document.addEventListener("shopify:section:unload", function (event) {
		if (event.target.classList.contains('gallery-with-text-section')) {
			stopAutoplay(event.target);
		}
	});

	initSection();
})();
